function PJQProjectWallAdminProjectReportsInitialize() {
	var i = 0;
	for (i = 0; i < settings.ReportItems.length; i++) {
		if (settings.ReportItems[i].ReportDisplayName != 'HIDE') {
			var option = "<option id='report_" + settings.ReportItems[i].ReportFileName.replace('/Customer/', '').toLowerCase() + "' value='" + settings.ReportItems[i].ReportId + "'>" + settings.ReportItems[i].ReportDisplayName + "</option>";
			jQuery('#project-report').append(option);
			if (settings.ReportItems[i].ReportDisplayName == "Mall Report") {
				if (settings.ProjectContainerId == 0 | settings.ProjectContainerId == null) {
					jQuery("#report_" + settings.ReportItems[i].ReportFileName.replace('/Customer/', '').toLowerCase()).hide();
				}
			}
		}
	}
	if (window.location.host.indexOf("panteratools.com") != -1) {
		jQuery('#project-report').append("<option label ='Custom Reports' value='PANTERAMARKETING'>Custom Reports</option>");
	}

	if(_.size(settings.ReportItemDefault) > 0){
		jQuery('#project-report').val(jQuery('#report_' + settings.ReportItemDefault.toLowerCase()).val());
	}
	else{
		jQuery('#project-report').val(jQuery('#project-report').find('option:first-child').attr('value'));
	}
}

var retryCount = 0;

function BuildReportProject() {
	jQuery('#report-content').html("<div class='loader'></div>");
	var reportId = jQuery('#project-report').val();

	var isProjectEstimate = false;
	for (var i = 0; i < settings.ReportItems.length; i++) {
		if (settings.ReportItems[i].ReportId.toString() == reportId && settings.ReportItems[i].ReportFileName == 'ProjectEstimates')
			isProjectEstimate = true;
	}

	if (reportId == 'PANTERAMARKETING') {
		jQuery('#report-content').html("<img style='width:100%;' src='/portals/_default/customReports.png'/>");
		jQuery('#refresh').hide();
		jQuery('#expacro').hide();
		jQuery('#expexc').hide();
		return;
	}
	else if (isProjectEstimate) {
		jQuery('#expacro').hide();
		jQuery('#expexc').hide();
		// ajax call to our aspx page to build excel file

		$.ajax({
			url: "/DesktopModules/PJQProjectWallAdmin/ExportProjectEstimates.aspx?sessionid=" + PJQ.app.session.id + "&x=" + (new Date).getTime(),
			dataType: 'text'
		}).done(function (result) {
			if (result == "NODATA")
				jQuery('#report-content').html("<div style='padding: 6px;'>There is currently no data for this report.</div>");
			else
				jQuery('#report-content').html("<div style='padding: 6px;'><a href='" + result + "'>Click here to download your report.</a></div>");
		}).fail(function (jqXHR, textStatus, errorThrown) {
		});

	}
	else {
		jQuery('#refresh').show();
		jQuery('#expacro').show();
		jQuery('#expexc').show();
		if (reportId == null && retryCount < 5) {
			setTimeout(function () {
				BuildReportProject();
				retryCount++;
			}, 500);
		}
		else {
			retryCount = 0;

			new PJQ.ajax.Request({
				endpoint: "/report/GenerateReport",
				data: {
					reportId: parseInt(reportId),
					projectId: PJQ.app.session.project ? PJQ.app.session.project.id : undefined,
					projectContainerId: projContainer ? projContainer.ProjectContainerId : undefined
				}
			}).post().done(function (data) {
				RenderReportProject(data);
			}).fail(function () {
			});
		}
	}
}

function RenderReportProject(data) {
	if (data.isImage) {
		$('#report-content').html($('<img>', {
			src: 'data:image/png;base64,' + data.reportData
		}));
	}
	else {
		$("#report-content").html($(data.reportData));
	}
	jQuery('#report-content div div table tbody tr td[width="100%"]').attr('width', '0px');
}

function BuildExportProject(exportType) {
	let reportId = jQuery('#project-report').val();

	if (PJQ.app.session)
		jQuery('#report-content').css('overflow', 'hidden').html("<div class='loader'></div>");

	if (PJQ.helpers.apiHelpers.isDebug) {
		PanteraScript.PanteraScriptService.GenerateExportNew(PJQ.app.session.id, 'project', exportType, reportId, '', BuildExportProjectC, onScriptError);
	} else {
		new PJQ.ajax.Request({
			endpoint: "/reports/export",
			data: {
				reportId: parseInt(reportId),
				projectId: PJQ.app.session.project ? PJQ.app.session.project.id : undefined,
				projectContainerId: projContainer ? projContainer.ProjectContainerId : undefined,
				exportType: exportType && exportType.toLowerCase() === "xls" ? 'excel' : 'pdf'
			}
		}).post().done(function (data) {
			jQuery('#report-content').css('overflow', 'auto').html("<div style='padding: 6px;'><a href='" + data.url + "'>Click here to download your export.</a></div>");
		}).fail(function () {
		});
	}
}

function BuildExportProjectC(response) {
	var rr = jQuery.parseJSON(response);
	jQuery('#report-content').css('overflow', 'auto').html("<div style='padding: 6px;'><a href='" + rr.DownloadURL + "'>Click here to download your export.</a></div>");
}